import { Box, styled } from '@mui/material';

export const StyledWelcomeSection = styled(Box)(({ theme }) => ({
	maxHeight: 650,
	overflowY: 'auto',
	padding: '20px 16px',
	[theme.breakpoints.down('sm')]: {
		borderBottom: `1px solid ${theme.palette.divider}`,
	},
}));
